import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ServerService } from '../../../service/server/server.service';
import { Params, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MaterialDetaileComponent } from "../material-detaile/material-detaile.component";
import { UserVideoComponent } from '../../../user/user-video/user-video.component';
import { MessageService } from '../../../service/message/message.service';
import { WharehouseOrderSaleSearialComponent } from '../../wharehouse-order-sale-searial/wharehouse-order-sale-searial.component';
import { MaterialFilterComponent } from '../material-filter/material-filter.component';

@Component({
  selector: 'app-material-list',
  templateUrl: './material-list.component.html',
  styleUrls: ['./material-list.component.scss']
})
export class MaterialListComponent implements OnInit, OnDestroy {
  //**********************************************************
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public user_id: number | undefined;
  public loading: boolean = false;
  public loading2: boolean = false;
  public navigate: boolean = false;
  public show_excel: boolean = false;
  public available: string = 'all';
  public wharehouse: boolean = false;
  public count_total: number = 1;
  public excel: number = 1;
  public page: number = 1;
  public asc_desc: string = 'asc';
  public order!: string;
  public subscription: Subscription | any;
  public server!: string;
  public server_main!: string;
  public site!: string;
  public task_type!: number;
  public confirm_delete!: boolean;
  public page_number_first!: number;
  public page_number_second!: number;
  public code!: any;
  public export_code!: string;
  public type_task!: number;
  public type!: number;
  public type_search!: number;
  public search_all!: string;
  public inventory: number = 0;
  public sum_inventory: number = 0;
  public invoice_buy: number = 0;
  public consumed_reception: number = 0;
  public invoice_sale: number = 0;
  public invoice_back_than_buy: number = 0;
  public invoice_back_than_sale: number = 0;
  public creator: number | undefined;
  public video: string | undefined;
  public access_service: number | undefined;
  public level: number | undefined;
  public path_export: string | undefined;
  public sum_price: number = 0;
  public sum_price2: number = 0;
  public sum_all: number = 0;
  public material_id: number = 0;
  public back_i!: number;
  public query_material_id: number;
  public list_record: any = [];
  //******************************************************************************
  public id: number | undefined;
  public pre_status: boolean | undefined; public next_status: boolean | undefined; public new_status: boolean | undefined;
  public title: string | undefined;
  public search_array: any = [];
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  public dataSource: any | undefined;
  public displayedColumns = ['row', 'title', 'inventory', 'group', 'cate', 'code', 'operation'];
  //************** */
  constructor(
    public serverService: ServerService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public messageService: MessageService,
    public dialogRef: MatDialog) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server_main();
    this.site = this.serverService.get_site();
  }
  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['id'];
      }
    );
    this.serverService.status1(2);
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.activatedRoute.queryParams.subscribe(
      (params: Params) => {
        this.query_material_id = params['materialId'];
        this.back_i = params['back_i'];
        this.search_all = params['search_all'];
        if (params['available']) {
          this.available = params['available'];
        }
        if (params['back_page'] > 0) {
          this.count_total = params['count_total'];
          this.page = params['back_page'] - 1;
          this.check_access(4, 2, 0, 1, 1);
        } else {
          this.check_access(4, 1, 0, 1, 1);
        }
      }
    );
    //**************
  }//end ngOnInit
  //****************************************************************************
  check_access(type_task: any, page: number, id: any, excel: number, loading: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, type: 'user', user_id: this.user_id, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.path_export = res['path_export'];
          this.access_service = res['result'][0].count;
          this.check_access2(type_task, page, id, excel, loading, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());

        }
      }
    )
  }
  check_access2(type_task: any, page: number, id: any, excel: number, loading: number, access_service: number): any {
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { 'address': 6, user_id: this.creator, id: this.code }).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());

            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());

            return false;
          }
          this.title = res['result'][0].title;
          this.video = res['result'][0].video;
          this.loading = false;
          if (type_task == 3) {
            this.delete(id);
          }
          if (type_task == 4) {
            this.load_data(page, excel, loading, -1);
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());

        }
      }
    )
  }
  load_data2(type: string) {
    this.available = type;
    this.navigate = false;
    this.load_data(1, 1, 1, -1);
  }
  load_data3() {
    this.navigate = true;
    this.available = '';
    this.load_data(1, 1, 1, -1);
  }
  sort(sort: string, asc_desc: string) {
    if (asc_desc == 'asc') this.asc_desc = 'desc';
    else this.asc_desc = 'asc';
    this.order = sort + " " + this.asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  reset_sort(sort: string, asc_desc: string) {
    this.order = sort + " " + asc_desc;
    this.load_data(1, 1, 1, -1);
  }
  load_data(page: number, excel: number, loading: number, changedRows: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5) { this.page = 1; }
    if (page == 6) { this.page = 1; }
    if (page == 1) { this.page = 1; }
    var obj = {
      'address': 6436,
      "page": this.page,
      'type': this.type,
      'excel': excel,
      'user_id': this.user_id,
      'search': this.search_array,
      'search_all': this.search_all,
      'changedRows': changedRows,
      'creator': this.creator,
      'path_export': this.path_export,
      'available': this.available,
      'navigate': this.navigate,
      'query_material_id': this.query_material_id,
      'order': this.order
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (excel == 1) {
            if (changedRows == -1) this.list_record = [];
            if (changedRows > 0 || changedRows == -1) {
              for (var i = 0; i < res['num']; i++) {
                res['result'][i].inventory_loading = false;
                res['result'][i].average_price = -1;
                this.list_record.push(res['result'][i]);
              }//end for
            }
            this.dataSource = new MatTableDataSource(this.list_record);
            this.count_total = res['count'];
            this.sum_price = res['sum_price'];
            this.sum_price2 = res['sum_price2'];
            this.sum_inventory = res['sum_inventory'];

            this.pages(0);
            this.serverService.change_window_resize(2, '', 0);
            this.serverService.send_services_id(this.code);
            this.serverService.send_reset({});
          }
          else if (excel == 2) {
            this.export_excel(res['export_code']);
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }//end else
      }//end res:Response
    ) //ens dubscribe
  }//end load data
  export_excel(code: number) {
    if (code > 0) {
      var x = <any>document.getElementById("excel");
      x.href = this.site + "/export/" + code + ".xlsx";
      x.click();
    }
  }
  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 20 - 19;
    this.page_number_second = this.page * 20;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 20 || (this.page * 20 >= this.count_total)) {
      this.page_number_second = this.count_total;
      this.next_status = true;
    }//end if
    else { this.next_status = false; }
  }
  open_video() {
    this.dialog.open(UserVideoComponent, {
      width: '45rem',
      height: 'auto',
      data: { id: this.code }
    })
  }
  open_serial(material_id: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading2 = true;
    var obj = {
      'address': 6681,
      'material_id': material_id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.dialog.open(WharehouseOrderSaleSearialComponent, {
            width: '22rem',
            height: 'auto',
            data: { id: res['result'][0].wharehouse_order_id, title: this.title, document_type_text: 'input', order_buy_id: 0 }
          })

          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  cardex(material_id: number) {
    window.open("/home/cardex/207?material=" + material_id, "_blank")
  }
  cardex_order(material_id: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading2 = true;
    var obj = {
      'address': 6681,
      'material_id': material_id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          window.open("/home/cardex/207?material=" + material_id + "&buyorderId=" + res['result'][0].wharehouse_order_id, "_blank")
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //***************************************************************************
  open_detaile(i: number, type_task: number, id: number) {
    var modal: any = MaterialDetaileComponent;
    var width = '65rem';
    if (type_task == 3) {
      modal = MaterialFilterComponent;
      width = '30rem';
    }
    const dialogRef = this.dialog.open(modal, {
      width: width,
      height: 'auto',
      disableClose: true,
      data: {
        type_task: type_task, id: id, i: i,
        search_array: this.search_array,
        code: this.code,
        title: this.title,
        creator: this.creator
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (type_task == 1) {
            this.list_record.unshift(res.result);
            this.pages(1);
            if (this.list_record.length == 21) {
              this.list_record.splice(20, 1);
            }
            this.dataSource.data = this.list_record;
          }
          else if (type_task == 2) {
            this.list_record[res.i].wharehouse = res.result.wharehouse;
            this.list_record[res.i].wharehouse_weight_title = res.result.wharehouse_weight_title;
            this.list_record[res.i].wharehouse_group_title = res.result.wharehouse_group_title;
            this.list_record[res.i].wharehouse_material_price = res.result.wharehouse_material_price;
            this.list_record[res.i].wharehouse_material_price2 = res.result.wharehouse_material_price2;
            this.list_record[res.i].wharehouse_material_title = res.result.wharehouse_material_title;
            this.list_record[res.i].wharehouse_material_coding = res.result.wharehouse_material_coding;
            this.list_record[res.i].wharehouse_material_sort = res.result.wharehouse_material_sort;
            this.list_record[res.i].wharehouse_material_cate_title = res.result.wharehouse_material_cate_title;
            this.list_record[res.i].status_title = res.result.status_title;
            this.list_record[res.i].inventory = res.result.inventory;
          }
          else if (type_task == 3) {
            var excel = res.export_excel;
            this.search_array = [];
            this.search_array = res;
            this.check_access(4, 1, 0, excel, 1);
          }
        }
      }
    )
  }
  get_bg(id: number) {
    this.id = id;
  }
  update_inventory(i: number) {
    var material_id = this.list_record[i].wharehouse_material_id;
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.list_record[i].inventory_loading = true;
    var obj = {
      address: 7246,
      material_id: material_id,
      creator: this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.list_record[i].inventory = res['result'][0].inventory;
          this.list_record[i].inventory_loading = false;
          this.message(true, this.messageService.message('با موفقیت آپدیت شد'), 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //*******************************************************************************
  delete(id: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var confirm_delete;
    confirm_delete = window.confirm(this.messageService.message_delete_accept());
    if (confirm_delete == true) {
      this.loading = true;
      var obj = {
        'address': 6039,
        "user_id": this.user_id,
        'id': id,
        "creator": this.creator,
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            this.list_record.splice(this.list_record.findIndex((index: any) => index.wharehouse_material_id == id), 1);
            this.dataSource.data = this.list_record;
            this.pages(-res['result'].changedRows);
            this.load_data(this.page, 1, 1, res['result'].changedRows);
            this.message(true, this.messageService.message_delete(), 1, this.messageService.close());
          }//end if
          else if (res['status'] == 4) {
            this.message(true, this.messageService.message_delete_alarm(), 1, this.messageService.close());
          }
          else {
            this.message(true, this.messageService.message_error(), 1, this.serverService.message_action());
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete
  go_to_cardex(i: number, material: number) {
    //this.show_financial = true;
    this.router.navigate(['/home/cardex/207'], {
      queryParams:
      {
        material: material,
        ref: this.code,
        page: this.page,
        available: this.available,
        search_all: this.search_all,
        count_total: this.count_total,
        link: 'material',
        service: 171,
        i: i,
      }
    })
  }
  open_report(id: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());

      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.material_id = id;
    this.loading2 = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6125, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.inventory = res['result'][0].wharehouse_material_inventory;
          this.invoice_buy = res['result'][0].invoice_buy;
          this.invoice_sale = res['result'][0].invoice_sale;
          this.invoice_back_than_buy = res['result'][0].invoice_back_than_buy;
          this.invoice_back_than_sale = res['result'][0].invoice_back_than_sale;
          this.consumed_reception = res['result'][0].consumed_reception;
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  //*******************************************************************************
  change_resize() {
    //this.serverService.change_window_resize(1,'',0);
  }//end change_resize
  //*******************************************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) {
      this.loading = false;
      this.loading2 = false;
    }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}


